import Image from 'next/image';
import React from 'react';

import { IImages } from '@/services/types/blog/post.types';
import backupImages from '@/utility/backupImages';

type IImageElement = React.ImgHTMLAttributes<HTMLImageElement>;

interface IBlogImage {
  images: IImages | null;
  title: string | null;
  className?: string;
  priority?: boolean;
  quality?: number;
}

const BlogPostImage: React.FC<IBlogImage & IImageElement> = ({
  images: preferredImages,
  title,
  className,
  priority = false,
  quality = 45,
}) => {
  const images = preferredImages || backupImages;

  return (
    <>
      <Image
        src={images?.full?.source_url || ''}
        alt={title || 'Outdoorsy Blog Post Image'}
        className={className}
        priority={priority}
        quality={quality}
        layout="fill"
        objectFit="cover"
        objectPosition="bottom"
      />
    </>
  );
};

export default BlogPostImage;
